import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog } from '@fortawesome/free-solid-svg-icons'

class SpinIcon extends React.Component {
  render() {
    return (
      <FontAwesomeIcon icon={faCog} size="3x" spin className="altColor" hidden={this.props.hidden || false} style={{ color: this.props.color || '#1647fb' }}/>
    );
  }
}

export default SpinIcon;
